import * as Yup from "yup";
import { isDomainName, isUGPhoneNumber } from "../../constants";

const AgroProcessorProfileSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  phoneNumber: Yup.string()
    .required("Phone number is required")
    .test(
      "is-ug-phone",
      "Phone number isn't a valid Ugandan phone number",
      (value) => !value || isUGPhoneNumber(value)
    ),
  address: Yup.string().required("Address is required"),
  website: Yup.string()
    .required("Website is required")
    .test(
      "is-domain",
      "Invalid website domain",
      (value) => !value || isDomainName(value)
    ),
  incorporationDate: Yup.date().required("Date of incorporation is required"),
  equipment: Yup.string().required("Equipment is required"),
  equipmentDescription: Yup.string().required(
    "A description of your equipment is required"
  ),
});

export default AgroProcessorProfileSchema;
